import {Component, Input} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import {CompanyImagePipe} from "../../../pipes/company-image.pipe";
import {BsModalRef, BsModalService, ModalOptions} from "ngx-bootstrap/modal";
import {CompanyModalComponent} from "../../modals/company-modal/company-modal.component";
import {Company} from "../../../models/company.model";

@Component({
  selector: 'app-answers-partners',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    CompanyImagePipe
  ],
  templateUrl: './answers-partners.component.html',
  styleUrl: './answers-partners.component.scss'
})
export class AnswersPartnersComponent {

  @Input() partners?: Company[];
  @Input() type?: string;

  modalRef!: BsModalRef;

  constructor(
    private modalService: BsModalService,
  ) {}

  openModalPartner(company: Company): void {
    const modalOptions: ModalOptions = {
      class: 'modal-lg modal-dialog-centered',
      initialState: {
        company: company
      }
    };
    this.modalRef = this.modalService.show(CompanyModalComponent, modalOptions);
  }
}
